import { palette } from '@/modules/defines/styles';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import '@/modules/defines/font.css';

export interface TabConfig {
  label: string;
  path: string;
}

interface CommonHeaderProps {
  title: string;
  backgroundColor: string;
  hoverColor?: string;
  tabs: TabConfig[];
  sessionCode: string;
  baseRoute: string;
}

const CommonHeader = ({
  title,
  backgroundColor,
  hoverColor,
  tabs,
  sessionCode,
  baseRoute,
}: CommonHeaderProps) => {
  const navigate = useNavigate();
  const currentPath = useLocation().pathname;

  const handleLogout = () => {
    sessionStorage.removeItem('sign');
    navigate('/sign');
  };

  return (
    <Container $backgroundColor={backgroundColor}>
      <LeftSection>
        <HeaderTitle>{title}</HeaderTitle>
        <Tabs>
          {tabs.map((tab) => (
            <Tab
              key={tab.path}
              $active={currentPath.includes(tab.path)}
              onClick={() => navigate(`${baseRoute}${tab.path}`)}
            >
              {tab.label}
            </Tab>
          ))}
        </Tabs>
      </LeftSection>
      <RightSection>
        <SessionInfo>
          <LogoutButton
            $backgroundColor={backgroundColor}
            $hoverColor={hoverColor}
            onClick={handleLogout}
          >
            로그아웃
          </LogoutButton>
        </SessionInfo>
      </RightSection>
    </Container>
  );
};

const Container = styled.div<{ $backgroundColor: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: ${(props) => props.$backgroundColor};
  color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderTitle = styled.h1`
  margin: 0;
  font-size: 1.5rem;
  color: ${palette.white};
  margin-right: 2rem;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
`;

const SessionInfo = styled.div`
  display: flex;
  align-items: center;
`;

const LogoutButton = styled.button<{
  $backgroundColor: string;
  $hoverColor?: string;
}>`
  background-color: white;
  color: ${(props) => props.$backgroundColor};
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: bold;
  padding: 0.5rem 1rem;
  margin-left: 1rem;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  &:hover {
    color: ${(props) => props.$hoverColor || props.$backgroundColor};
    background-color: #eeeeee;
  }
`;

const Tabs = styled.div`
  display: flex;
  margin-left: 1rem;
`;

const Tab = styled.div<{ $active: boolean }>`
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
  cursor: pointer;
  font-weight: ${(props) => (props.$active ? 'bold' : 'normal')};
  color: ${(props) => (props.$active ? 'white' : 'rgba(255, 255, 255, 0.7)')};
  border-bottom: 2px solid
    ${(props) => (props.$active ? 'white' : 'transparent')};
  transition: all 0.2s ease;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;

  &:hover {
    color: white;
  }
`;

export default CommonHeader;
